import React, {useRef, useState} from 'react';
import './nativeStyles/styles.css'
import './nativeStyles/default.css'
import './DateRangePicker.sass'
import {DateRange} from 'react-date-range';
import * as locales from 'react-date-range/dist/locale';

import * as moment from "moment";
import icons from "../../../assets/icons";
import useOutsideClick from "../../../hooks/useOutsideClick";
import PropTypes from "prop-types";

function DateRangePicker(props) {
    const [show, setShow] = useState(false)
    const myRef = useRef()

    useOutsideClick(myRef, () => {
        if (show) setShow(false)
    })

    return (
        <div ref={myRef} onKeyPress={props.onKeyPress} className={'DateRangePicker'}>
            <div  style={{background: props.bg}} onClick={_ => setShow(!show)} className="input">
                {props.value[0].startDate
                && props.value[0].endDate
                    ? <div
                        style={{color: 'black'}}>{moment(props.value[0].startDate).format('DD-MM-YYYY')} ~ {props.value[0].endDate ? moment(props.value[0].endDate).format('DD-MM-YYYY') : ''}</div>
                    : 'Дата'}
                <div className="arrow">
                    <img src={icons.arrowDown} alt="open"/>
                </div>
            </div>
            {show ? <div onClick={_ => setShow(false)} className="close"><i className="fas fa-times"/></div> : ''}
            {show ?
                <div className='DateRangePicker__calendar'>
                    <DateRange
                        editableDateInputs={false}
                        onChange={item => props.onChange([item.selection])}
                        moveRangeOnFirstSelection={false}
                        ranges={props.value}
                        endDatePlaceholder={"По"}
                        startDatePlaceholder={"С"}

                        locale={locales.ru}
                    />
                </div>
                : ''}
        </div>
    )
}

export default DateRangePicker